var _path, _path2, _polygon, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.12,121.21H63.06v51.41H75.79v-20h7.33c10.35,0,18.16-6.75,18.16-15.7a14.47,14.47,0,0,0-4.35-10.32A19.48,19.48,0,0,0,83.12,121.21Zm5.16,15.7c0,3.06-2.06,4.81-5.65,4.81H75.79v-9.61h6.84C87.69,132.11,88.28,134.85,88.28,136.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.75,121.21H105.48v51.41h20.34c14.76,0,26.31-11.31,26.31-25.74C152.13,132.72,140.3,121.21,125.75,121.21Zm13.38,25.68c0,8.19-6,14.85-13.38,14.85h-7.54V132.11h7.54C133.38,132.11,139.13,138.46,139.13,146.89Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "192.94 132.11 192.94 121.21 157.74 121.21 157.74 172.63 170.46 172.63 170.46 151.84 188.16 151.84 188.16 140.95 170.46 140.95 170.46 132.11 192.94 132.11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.55,0H24.68V256H231.32V61.77Zm4.37,57.4V25.47L205.83,57.4Zm42.47,14.92V241.08h-176V14.92H159v57.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.8f38ed97.svg";
export { ForwardRef as ReactComponent };